import * as React from "react"
import "./_modal-right.scss"

const ModalRight = ({
  children,
  modalid,
  isvisible,
  onclose,
  footer,
  ...atomProps
}) => {
  return (
    <div id={modalid} className="modal fade right modal-right">
      <div className="close-button d-none d-md-flex">
        <button
          type="button"
          className="btn-close m-0"
          data-bs-dismiss="modal"
        ></button>
      </div>
      <div className="modal-dialog modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div> </div>
            <div className="close-button d-md-none">
              <button
                type="button"
                className="btn-close m-0"
                data-bs-dismiss="modal"
              ></button>
            </div>
          </div>
          <div className="modal-body">
            <div className="container-fluid">{children}</div>
          </div>
          {footer && <div className="modal-footer">{footer}</div>}
        </div>
      </div>
    </div>
  )
}

export default ModalRight
